import { Controller } from "@hotwired/stimulus"

// Column Filter — 헤더 클릭 시 팝오버 열림/닫힘 + 체크박스 다중 선택
// 사용: app/views/components/_column_filter.html.erb 참고
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    event.stopPropagation()
    event.preventDefault()
    // 한 번에 하나만 열리도록, 다른 컬럼 필터 패널은 모두 닫는다.
    // (toggle 이 stopPropagation 하므로 다른 컨트롤러의 outsideClose 가 발동하지
    //  않아, 여기서 직접 닫아준다.)
    document.querySelectorAll('[data-column-filter-target="panel"]').forEach((panel) => {
      if (panel !== this.panelTarget) panel.classList.add("hidden")
    })
    this.panelTarget.classList.toggle("hidden")
  }

  close() {
    this.panelTarget.classList.add("hidden")
  }

  // window 클릭 시, 팝오버 밖 클릭이면 닫기.
  outsideClose(event) {
    if (this.panelTarget.classList.contains("hidden")) return
    if (this.element.contains(event.target)) return
    this.close()
  }

  selectAll(event) {
    event.preventDefault()
    this.checkboxes().forEach((cb) => (cb.checked = true))
  }

  clearAll(event) {
    event.preventDefault()
    this.checkboxes().forEach((cb) => (cb.checked = false))
  }

  checkboxes() {
    return this.panelTarget.querySelectorAll('input[type="checkbox"]')
  }
}
